import { Component, Input, OnDestroy, AfterViewInit, EventEmitter, Output } from '@angular/core'
import { AuthService } from '../../../insa-services';

@Component({
  templateUrl: 'mainWindowFavorites.component.html',
  selector: 'favorites-widget'
})

export class MainWindowFavorites implements OnDestroy, AfterViewInit {
  @Input('widgetList') widgetList : Array<Object>;
  @Output() widgetListChange = new EventEmitter<Array<Object>>();
  @Input('languageList') languageList : Array<String>;
  @Input('selectedLanguage') selectedLanguage : String;
  @Output() selectedLanguageChange = new EventEmitter<String>();

  constructor (private _authService: AuthService) {
  }

  ngAfterViewInit () {
  }

  ngOnDestroy () {
  }

  // showLanguageDialog () {
  //   $('#mainWindowLanguageModal').modal('show');
  // }

  // closeLanguageDialog () {
  //   $('#mainWindowLanguageModal').modal('hide');
  //   this.selectedLanguageChange.emit(this.selectedLanguage);
  // }

  // showConfigureDialog () {
  //   $('#mainWindowSettingsModal').modal('show');
  // }

  // closeConfigureDialog () {
  //   $('#mainWindowSettingsModal').modal('hide');
  //   this.widgetListChange.emit(this.widgetList);
  // }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-main/insa-main-widgets/mainWindowFavorites.component.ts